// Constants for file sizes in bytes.
export const ONE_MB = 1048576;
export const HALF_MB = ONE_MB / 2;
export const FIVE_MB = 5 * ONE_MB;
export const TEN_MB = 10 * ONE_MB;
export const MAX_IMAGE_UPLOAD_SIZE = 20 * ONE_MB;
export const COMPRESSION_RETRY_LIMIT = 2;
export const RETRY_DELAY_MS = 1000;
export const UPLOAD_RETRY_LIMIT = 2;
export const ERROR_NAME_MAX_UPLOAD_SIZE_EXCEEDED = 'MaxImageUploadSizeExceeded';
export const ERROR_NAME_UPLOAD_FAILED = 'ImageUploadFailed';
export const ERROR_NAME_COMPRESSION_FAILED = 'ImageCompressionFailed';
export const ERROR_NAME_HEIC_DETECTION_FAILED = 'HeicDetectionFailed';
export const ERROR_NAME_HEIC_CONVERSION_FAILED = 'HeicConversionFailed';
